import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DialogDescription,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { AlertTriangle, Loader } from "lucide-react";

interface TransferRoleModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading: boolean;
  targetRole: string;
  currentHolderName: string;
  newHolderName: string;
}

export default function TransferRoleModal({
  open,
  onClose,
  onConfirm,
  isLoading,
  targetRole,
  currentHolderName,
  newHolderName,
}: TransferRoleModalProps) {
  return (
    <Dialog open={open} onOpenChange={(isOpen) => { if (!isOpen) onClose(); }}>
      <DialogContent className="sm:max-w-[480px]">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-lg">
            <AlertTriangle className="h-5 w-5 text-amber-500" />
            Transfer {targetRole}
          </DialogTitle>
          <DialogDescription className="text-[14px] pt-2 leading-7 text-gray-600">
            <strong>{currentHolderName}</strong> is currently the {targetRole} of this cooperative.
            <br /><br />
            If you continue:
            <br />
            &bull; <strong>{currentHolderName}</strong> will be changed to Member.
            <br />
            &bull; <strong>{newHolderName}</strong> will become the new {targetRole}.
            <br /><br />
            This action will take effect immediately.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={isLoading}>
            Cancel
          </Button>
          <Button
            onClick={onConfirm}
            disabled={isLoading}
            className="bg-amber-600 hover:bg-amber-700 text-white"
          >
            {isLoading && <Loader className="mr-2 h-4 w-4 animate-spin" />}
            Transfer {targetRole}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
